// @ts-nocheck
import {
    GetGreifOrderUploadApiParameter,
    uploadOrderCreateCart,
} from "@store/Framework/Services/GreifOrderUploadService";
import { GreifOrderUploadState } from "@store/Framework/Store/Greif/Components/GreifOrderUpload/GreifOrderUploadState";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = HasOnError & HasOnSuccess;
type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetGreifOrderUploadApiParameter, GreifOrderUploadState>;

export const DispatchBeginCreateCartUpload: HandlerType = props => {
    props.dispatch({
        type: "Greif/ComponentsReducer/GreifOrderUpload/BeginCreateCartUpload",
    });
};

export const CreateCartUpload: HandlerType = async props => {
    const result = await uploadOrderCreateCart();
    if (result.successful) {
        const { webOrderNumber } = result.result;
        props.apiResult = result.result;
        props.dispatch({
            type: "Greif/ComponentsReducer/GreifOrderUpload/DispatchSuccessfulCreateCartResults",
            webOrderNumber,
        });
    } else {
        props.parameter?.onError?.(result as any);
        props.dispatch({
            type: "Greif/ComponentsReducer/GreifOrderUpload/FailedToCreateCartUpload",
        });
    }
};

export const DispatchCompleteCreateCartUpload: HandlerType = props => {
    props.dispatch({
        type: "Greif/ComponentsReducer/GreifOrderUpload/CompleteCreateCartUpload",
    });
};

export const chain = [DispatchBeginCreateCartUpload, CreateCartUpload, DispatchCompleteCreateCartUpload];

const createCartUpload = createHandlerChainRunner(chain, "CreateCartUpload");
export default createCartUpload;
